var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1669971417342,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6912,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M919.04 292.352v-49.664H122.368v54.784l386.56 263.168c0.512 0.512 1.536 0.512 2.56 0l404.48-266.752 3.072-1.536z m0 67.584L542.72 608.256c-19.968 13.312-46.08 13.312-66.048 0L122.368 366.592v444.928h796.672V359.936z m-796.672-174.08h796.672c31.232 0 56.832 25.6 56.832 56.832v568.832c0 31.232-25.6 56.832-56.832 56.832H122.368c-31.232 0-56.832-25.6-56.832-56.832V242.688c0-31.232 25.6-56.832 56.832-56.832z",
    fill: "",
    "p-id": 6913
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.4a55cb94.svg";
export { ForwardRef as ReactComponent };